export const POST_COORDINATOR_RESULT_RELEASE_SEARCH_PARAM = '/results/search';
export const GET_COORDINATOR_CANDIDATE_RELEASE_BY_INDEX_NO='/results';
export const BULK_DOWNLOAD_COORDINATOR_RESULT_RELEASE = '/results';
